import { createApp } from 'vue';
import App from './App.vue';
import store from './store/index.js';
import router from './router/index.js';
import ElementPlus from 'element-plus';
import './assets/iconfont/iconfont.css';
import 'element-plus/dist/index.css';
import 'element-plus/theme-chalk/el-infinite-scroll.css';
import './assets/styles.css'; // 引入全局样式文件
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import axios from 'axios'
import mitt from 'mitt'
import { ElMessageBox } from 'element-plus'

// 定义外部API列表
const externalApis = [
    'api.map.baidu.com',
    'api.deepseek.com',
    'api.coze.cn',
    'ip.nixiaofeng.com'
];
const noTokenApis = [
    '/auth/login',
    '/auth/register',
    '/flight/flightinstances/query/page',
    '/file',
];

// 设置axios默认baseURL
// 根据环境使用不同的前缀
// 生产环境使用/api，开发环境使用/dev
// 从store中获取API_PREFIX
axios.defaults.baseURL = store.getters.getAPI_PREFIX;

// 启用跨域请求时发送凭据（cookies）
axios.defaults.withCredentials = true;
// 设置请求头的内容类型
axios.defaults.headers.common['Content-Type'] = 'application/json';

const noTokenApi = (url) => {
    return noTokenApis.some(api => url.includes(api));
};
// 检查是否是外部API
const isExternalApi = (url) => {
    return externalApis.some(api => url.includes(api));
};

// 请求拦截器
axios.interceptors.request.use(
    async config => {
        // 如果是外部API或完整URL请求，清除baseURL
        if (isExternalApi(config.url) || config.url.startsWith('http')) {
            config.baseURL = ''; // 清除baseURL
            config.withCredentials = false; // 外部API请求不发送凭据
        }
        // 如果是FormData，自动删除Content-Type，让浏览器自动设置multipart/form-data及boundary
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 用于防止多个401同时弹窗
let isShowingAuthError = false;

// 设置响应拦截器
axios.interceptors.response.use(
    response => {
        // 如果是外部API，直接返回response，不做处理
        if (isExternalApi(response.config.url)) {
            return response;
        }
        return response.data
    },
    error => {
        if (error.response?.status === 401) {
            // 清除前端状态，cookies会由后端清除
            store.commit('user/clearUser', null, { root: true });
            store.commit('auth/removeToken', null, { root: true });
            // 避免多个请求同时弹出多个401提示框
            if (!isShowingAuthError) {
                isShowingAuthError = true;
                ElMessageBox.confirm(
                    '登录已失效，是否重新登录',
                    '提示',
                    {
                        confirmButtonText: '重新登录',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                ).then(() => {
                    // 用户点击确认，跳转到登录页
                    router.push('/login');
                }).catch(() => {
                    // 用户点击取消，不做操作
                }).finally(() => {
                    isShowingAuthError = false;
                });
            }
        }
        return Promise.reject(error)
    }
);

const app = createApp(App);
const eventBus = mitt()

// 添加事件总线
app.config.globalProperties.$bus = eventBus

app.use(store);
app.use(router);
app.use(ElementPlus, { locale: zhCn });
app.mount('#app');